import FallbackUI from "FallbackUI";
import React, { Component } from "react";
import { captureGlobalError } from "utils/errorCapture";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // Capture the error in the render phase so FallbackUI's useState/useEffect
  // see it on mount. componentDidCatch fires AFTER FallbackUI has already
  // mounted and read sessionStorage — too late for the auto-redirect URL,
  // which is why ?crcnt=N&time=... was landing without msg/version.
  // React asks this hook to be pure; a sessionStorage write is idempotent
  // and safe to repeat in StrictMode / concurrent mode.
  static getDerivedStateFromError(error) {
    captureGlobalError({
      source: "react",
      message: error && error.message,
      error,
    });
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Re-write to upgrade the payload with componentStack — only available
    // here, not in getDerivedStateFromError. Lets the FallbackUI redirect URL
    // include component= / caller= so the access-log entry points at the
    // exact React component that crashed, not just the chunk file.
    captureGlobalError({
      source: "react",
      message: error && error.message,
      error,
      componentStack: errorInfo && errorInfo.componentStack,
    });
    // eslint-disable-next-line no-console
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <FallbackUI />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
